module.exports = __webpack_public_path__ + "img/icons BFr_29.dc400de6.svg";